__turbopack_context__.v({
  "check": "lx4zhG_check",
  "chevron": "lx4zhG_chevron",
  "dialog": "lx4zhG_dialog",
  "empty": "lx4zhG_empty",
  "english": "lx4zhG_english",
  "enter": "lx4zhG_enter",
  "globe": "lx4zhG_globe",
  "input": "lx4zhG_input",
  "list": "lx4zhG_list",
  "name": "lx4zhG_name",
  "names": "lx4zhG_names",
  "option": "lx4zhG_option",
  "optionFlag": "lx4zhG_optionFlag",
  "optionGlobe": "lx4zhG_optionGlobe",
  "original": "lx4zhG_original",
  "root": "lx4zhG_root",
  "search": "lx4zhG_search",
  "searchIcon": "lx4zhG_searchIcon",
  "short": "lx4zhG_short",
  "trigger": "lx4zhG_trigger",
  "triggerFlag": "lx4zhG_triggerFlag",
});
